import { ColorPalette } from "@design-lab/shared/ui/ColorPalette";
import type { Color, Product } from "@design-lab/shared/types/base";
import { SelectedColorDisplay } from "./SelectedColorDisplay";

type ColorSelectProps = {
  selectedColor: Color | undefined;
  recommendedColors: Color[];
  allColors: Color[];
  onColorSelect: (id: string) => void;
  showAllColors: boolean;
  showViewAllButton?: boolean;
  showToggleButton?: boolean;
  onToggleShowAll?: (show: boolean) => void;
  showAllRecommended?: boolean;
  showRecommendedToggle?: boolean;
  onToggleShowAllRecommended?: (show: boolean) => void;
  maxColors?: number;
  product?: Product | undefined;
  onAddColor?: () => void;
  onRemoveComposition?: () => void;
  showRemoveButton?: boolean;
  isSimplified?: boolean;
  onColorHover?: (id: string) => void;
  onColorBlur?: () => void;
};

export function ColorSelect(props: ColorSelectProps) {
  const {
    selectedColor,
    recommendedColors,
    allColors,
    onColorSelect,
    showAllColors,
    showToggleButton = true,
    onToggleShowAll,
    showAllRecommended = false,
    showRecommendedToggle = false,
    onToggleShowAllRecommended,
    maxColors,
    onColorHover,
    onColorBlur
  } = props;

  if (!selectedColor && !showToggleButton) return null;

  return (
    <section className="space-y-4 rounded-md border p-2">
      {selectedColor && (
        <SelectedColorDisplay selectedColor={selectedColor} className="lg:hidden" />
      )}
      {selectedColor && (
        <ColorPalette
          recommendedColors={recommendedColors}
          otherColors={allColors}
          onColorSelect={onColorSelect}
          selectedColor={selectedColor}
          showToggleButton={showToggleButton}
          showAllColors={showAllColors}
          {...(onToggleShowAll && { onToggleShowAll })}
          showRecommendedToggle={showRecommendedToggle}
          showAllRecommended={showAllRecommended}
          {...(onToggleShowAllRecommended && { onToggleShowAllRecommended })}
          maxColors={maxColors || 24}
          {...(onColorHover && { onColorHover })}
          {...(onColorBlur && { onColorBlur })}
        />
      )}
    </section>
  );
}
